webpackJsonp([29602271593436],{

/***/ 1353:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ApproveCubexEncounterProductInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"encounterId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"providerId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-approve-cubex-encounter-product-input-2ec753df07bcfa606656.js